
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ICustomDomainsForDropdown } from './customdomains-model';
import { CustomDomainType } from '@shared/enums/CustomDomainType';

@Injectable()
export class CustomDomainsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${CustomDomainsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/customdomains';

    public getCustomDomainsForDropdown(customDomainType: CustomDomainType): Observable<SuccessResponse<ICustomDomainsForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ICustomDomainsForDropdown>>(CustomDomainsService.URL + '/dropdown/' + customDomainType).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
